import { createFileRoute } from '@tanstack/react-router'
import { ContractsRegisterPage } from '../../../../features/contracts/register-page'
import { contractsSearchSchema } from '../../../../features/contracts/search'

export const Route = createFileRoute('/_app/service/contracts/')({
  validateSearch: contractsSearchSchema,
  component: ContractsRegisterPage,
})
